import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-18 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2 text-center">
          用户评价
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          来自真实用户的观影反馈与好评
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="p-5 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.date}</p>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: comment.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs text-accent-500"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}